import React from 'react';
import { Route, Switch } from 'react-router-dom';
import List from './List';
import Show from './Show';

export default class Settlements extends React.Component {
  render = () => {
    const { match } = this.props;
    return (
      <div>
        <Switch>
          <Route exact path={match.url} component={List}/>
          <Route exact path={`${match.url}/:loanNumber`} component={Show}/>
        </Switch>
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/Loans/index.js